import { FC } from "react";
import AnchorDataList from "@/components/anchorData/anchorDataList";
import RestrictedPage from "@/consumer/restrictedPage";
import { useTranslation } from "react-i18next";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";

const AnchorData: FC = () => {
  const { t } = useTranslation();
  usePageHeading(t("anchorData_navigation"));
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];
  return (
    <RestrictedPage permissionRequired="frontend_view_anchordata">
      <AnchorDataList subdomain={subdomain} />
    </RestrictedPage>
  );
};

export default AnchorData;
